// @flow

import React from 'react';

import {
  Clamp,
  Header2,
  injectSheet,
  type InjectSheetProvidedProps
} from '@catalytic/catalytic-ui';

export const Style = () => ({
  root: {
    textAlign: 'center',
    margin: '0.5rem 1rem',
    padding: '0.313rem'
  }
});

type Props = InjectSheetProvidedProps & {
  className: string,
  headlineText: string
};

export const LoginHeadline = ({ classes, headlineText }: Props) => {
  return (
    <Header2 className={classes.root} data-testid="login-headline">
      <Clamp clamp={2}>{headlineText}</Clamp>
    </Header2>
  );
};

LoginHeadline.displayName = 'LoginHeadline';

export default injectSheet(Style)(LoginHeadline);
